import { Controller } from "@hotwired/stimulus"

// Attached to the CP2020 stats grid. Two roles, same source-broadcasts /
// consumer-listens pattern as the role and childhood controllers:
//
//   MESSAGES — announces a change to any base stat (or its bonus) via a
//   window-level cp2020:stats-changed event (the grid's `input` action), so
//   consumers (computed-stats, skills) recompute.
//
//   ANSWERS — exposes base stat values so a consumer ASKS this controller (via a
//   Stimulus outlet) rather than reaching into the form itself. Consumers hydrate
//   on outletConnected and re-pull on the stats-changed message.
export default class extends Controller {
  // The sheet form owns field access (see cp2020--sheet).
  static outlets = ["cp2020--sheet"]

  broadcast() {
    this.dispatch("stats-changed", { prefix: "cp2020", target: window })
  }

  // The BASE value of a stat by abbreviation ("INT", "REF", ...) — no _bonus,
  // since chargen budgets (e.g. pickup skills = INT + REF) use base stats. 0 when
  // blank/unset. Reads the field via the sheet outlet (not closest("form")).
  value(abbr) {
    return this.hasCp2020SheetOutlet ? this.cp2020SheetOutlet.intField(`stat_${abbr.toLowerCase()}`) : 0
  }
}
